import React from "react";
import SectionHeader from "@/components/shared/SectionHeader";
import { useI18n } from "@/lib/i18n";

const BDSectors = () => {
  const { t } = useI18n();
  return (
    <div>
      <section className="py-28 lg:py-36 bg-[#FAFAFA] border-b border-[#0A192F]/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <SectionHeader
            number={t("sec.hero.number")}
            eyebrow={t("sec.hero.eyebrow")}
            title={t("sec.hero.title")}
            body={t("sec.hero.body")}
          />
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0A192F]/10">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="bg-white p-10 lift-card relative overflow-hidden group">
                <div className="absolute -top-6 -right-2 font-eisg text-7xl text-[#0A192F]/5 group-hover:text-[#D4AF37]/15 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="section-num">— {String(i + 1).padStart(2, "0")}</div>
                <h3 className="mt-5 font-bd text-2xl text-[#0A192F] tracking-tight">{t(`sec.items.${i}.title`)}</h3>
                <p className="mt-3 text-[#0A192F]/70 leading-relaxed">{t(`sec.items.${i}.desc`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BDSectors;
